module.exports = __webpack_public_path__ + "img/rare-aquatic-finds.216ebe66.jpg";